(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3696],{

/***/ 93696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ShopCategoryList; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(52709);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/categoryCard/v1.module.scss
var v1_module = __webpack_require__(14363);
var v1_module_default = /*#__PURE__*/__webpack_require__.n(v1_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/image.js
var next_image = __webpack_require__(86430);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(21867);
;// CONCATENATED MODULE: ./components/categoryCard/v1.tsx






function CategoryCard(param) {
    let { data  } = param;
    var ref, ref1;
    const { query  } = (0,router.useRouter)();
    const handleQuery = (categoryId)=>{
        if (Number(query === null || query === void 0 ? void 0 : query.category_id) === categoryId) {
            return {
                ...query,
                category_id: undefined
            };
        }
        return {
            ...query,
            category_id: categoryId
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: {
            query: handleQuery(data === null || data === void 0 ? void 0 : data.id)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((v1_module_default()).card, " ").concat(Number(query === null || query === void 0 ? void 0 : query.category_id) === (data === null || data === void 0 ? void 0 : data.id) ? (v1_module_default()).active : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    width: 30,
                    height: 30,
                    className: (v1_module_default()).img,
                    alt: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                    src: (data === null || data === void 0 ? void 0 : data.img) || ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (v1_module_default()).text,
                    children: data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(59164);
// EXTERNAL MODULE: ./containers/shopCategoryList/v1.module.scss
var shopCategoryList_v1_module = __webpack_require__(36956);
var shopCategoryList_v1_module_default = /*#__PURE__*/__webpack_require__.n(shopCategoryList_v1_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(53440);
;// CONCATENATED MODULE: ./containers/shopCategoryList/v1.tsx









function ShopCategoryList(param) {
    let { data , loading , parent  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shopCategoryList_v1_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (shopCategoryList_v1_module_default()).title,
                children: t("categories")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: !loading && (data === null || data === void 0 ? void 0 : data.length) === 0 ? "none" : "block",
                    background: "var(primary-bg)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    className: "full-width",
                    modules: [
                        swiper_esm/* Navigation */.W_
                    ],
                    navigation: true,
                    slidesPerView: "auto",
                    spaceBetween: 10,
                    children: [
                        !!parent && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            style: {
                                maxWidth: "max-content"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/shop-category/".concat(parent),
                                shallow: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (shopCategoryList_v1_module_default()).card,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (shopCategoryList_v1_module_default()).text,
                                        children: t("all")
                                    })
                                })
                            })
                        }),
                        loading ? Array.from(Array(10).keys()).map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (shopCategoryList_v1_module_default()).swiperSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rectangular",
                                    className: (shopCategoryList_v1_module_default()).shimmer
                                })
                            }, item)) : data === null || data === void 0 ? void 0 : data.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: (shopCategoryList_v1_module_default()).swiperSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCard, {
                                    data: category,
                                    parent: parent
                                })
                            }, category.id))
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 14363:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"v1_card__vZ8Zq","active":"v1_active___1OE2","img":"v1_img__Pkq7P","text":"v1_text___e43I"};

/***/ }),

/***/ 36956:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"v1_container__4DKRy","title":"v1_title__S4qxw","swiperSlide":"v1_swiperSlide__yiAEb","shimmer":"v1_shimmer__pFUE9","card":"v1_card__dr1_z","active":"v1_active__94rQb","text":"v1_text__aeMs_"};

/***/ })

}]);